import { quillEditor, Quill } from "vue-quill-editor"; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// import  { SizeClass } from 'quill/dist/quill';
// console.log(SizeClass)
//设置字体大小
let fontSizeStyle = Quill.import('attributors/class/size') //引入这个后会把样式写在style上
fontSizeStyle.whitelist = [false, '14', '16', '18', '20', '22', '24', '28', '32', '36']
Quill.register(fontSizeStyle, true)

let fontSizeStyle1 = Quill.import('attributors/style/size') //引入这个后会把样式写在style上
fontSizeStyle1.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px', '36px']
Quill.register(fontSizeStyle1, true)

//设置字体样式
let Font = Quill.import('attributors/class/font') //引入这个后会把样式写在style上
Font.whitelist = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] //将字体加入到白名单
Quill.register(Font, true)

let Font1 = Quill.import('attributors/style/font') //引入这个后会把样式写在style上
Font1.whitelist = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] //将字体加入到白名单
Quill.register(Font1, true)

export let mixinRichtext = {
  data() {
    return {
      editorOption: {//配置工具栏
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
            ['blockquote', 'code-block'], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
            [{ script: 'sub' }, { script: 'super' }], // 上标/下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ direction: 'rtl' }], // 文本方向
            [{ size: ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px', '36px'] }], // 字体大小
            // [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial','sans-serif'] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['image', 'video'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入内容..',
        theme: 'snow'
      }
      // 背景颜色 - background
      // 加粗- bold
      // 颜色 - color
      // 字体 - font
      // 内联代码 - code
      // 斜体 - italic
      // 链接 - link
      // 大小 - size
      // 删除线 - strike
      // 上标/下标 - script
      // 下划线 - underline
      // 引用- blockquote
      // 标题 - header
      // 缩进 - indent
      // 列表 - list
      // 文本对齐 - align
      // 文本方向 - direction
      // 代码块 - code-block
      // 公式 - formula
      // 图片 - image
      // 视频 - video
      // 清除字体样式- clean
    };
  },
  components: {
    Editorr:quillEditor
  },
  mounted() {
  },
  methods: {

    // 失去焦点事件
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    }
  }
};
